// components
import Button from "../../../../components/Button/Button";
import Typography from "../../../../components/Typography/Typography";

// styled components
import { WrapperContent, WrapperBtn } from "./wrapperBtnStyle";

const WrapperButton = ({ activePage, setActivePage }) => {
  return (
    <WrapperContent>
      <WrapperBtn active={activePage === "مدیریت ارسال پیام" && true}>
        <Button
          bgColor="transparent"
          onclick={() => setActivePage("مدیریت ارسال پیام")}
        >
          <Typography size="14px" weight="bold">
            مدیریت ارسال پیام
          </Typography>
        </Button>
      </WrapperBtn>
      <WrapperBtn active={activePage === "مدیریت ورودی ها" && true}>
        <Button
          bgColor="transparent"
          onclick={() => setActivePage("مدیریت ورودی ها")}
        >
          <Typography size="14px" weight="bold">
            مدیریت ورودی ها
          </Typography>
        </Button>
      </WrapperBtn>
    </WrapperContent>
  );
};

export default WrapperButton;
